// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"02d5a98e","453":"ce2274b2","952":"59a96fa7"}[chunkId] + ".chunk.js";
};